module.exports = "https://static.im-cdn.com/mjc/storefront/Sakra/static/media/Email.824430b1.svg";